import React from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import * as roomActions from '../../actions/roomActions';
import PropTypes from 'prop-types';
import { useIntl, FormattedMessage } from 'react-intl';

import { Tabs, Tab, Grid, Button } from '@material-ui/core';

import VolumeSettings from './VolumeSettings';
import VideoSettings from './VideoSettings';
import VirtualBgSettings from './VirtualBgSettings';
import AppearanceSettings from './AppearanceSettings';

import TabIcon  from './TabIcon';

import { Dialog, DialogTitle, DialogContent, DialogActions } from '@material-ui/core';

const tabs = window.config.virtualBgEnable ?
[
	'audio',
	'video',
	'virtualBg',
	'appearance'
] : [
	'audio',
	'video',
	'appearance'
];

const styles = (theme) => ({
	dialogTitle : {
		paddingBottom : '0px'
	},
	dialogContent : {
		backgroundColor: theme.palette.background.paper,
		// minHeight : '40vh'
		minHeight    : '600px'
	},
	dialogPaper :
	{
		// minHeight                      : '600px',
		width                          : '50vw',
		[theme.breakpoints.down('lg')] :
		{
			width : '60vw'
		},
		[theme.breakpoints.down('md')] :
		{
			width : '70vw'
		},
		[theme.breakpoints.down('sm')] :
		{
			width : '80vw'
		},
		[theme.breakpoints.down('xs')] :
		{
			width : '90vw'
		}
	},
	tabsHeader :
	{
		//flexGrow : 1
		borderRight: `1px solid ${theme.palette.divider}`
	},
	tabNavItem : {
		flexDirection : 'row',
		justifyContent : ' flex-start'
	}
});

const Settings = ({
	currentSettingsTab,
	settingsOpen,
	handleCloseSettings,
	setSettingsTab,
	classes
}) => {
	const intl = useIntl();

	return (
		<Dialog
			maxWidth="md"
			open={settingsOpen}
			onClose={() => handleCloseSettings(false)}
			classes={{
				paper : classes.dialogPaper
			}}
		>
			<DialogTitle id='form-dialog-title' className={classes.dialogTitle}>
				<FormattedMessage
					id='settings.settings'
					defaultMessage='Settings'
				/>
			</DialogTitle>

			<DialogContent className={classes.dialogContent}>
				<Grid container>
					<Grid item xs={3}>
						<Tabs
							orientation="vertical"
							variant="scrollable"
							className={classes.tabsHeader}
							value={tabs.indexOf(currentSettingsTab)}
							onChange={(event, value) => setSettingsTab(tabs[value])}
							indicatorColor='#fff'
							textColor='primary'
						>

							{tabs.map((item) => {

								return <Tab
										classes={{
											wrapper: classes.tabNavItem
										}}
										icon={<TabIcon tab={item} selected={currentSettingsTab === item ? 1 : 0} />}
										label={
										<span>
											<FormattedMessage
												id={`label.${item}`}
												defaultMessage={`${item} setting`}
											/>
										</span>}
									/>
							})}

						</Tabs>
					</Grid>
					<Grid item xs={9}>

						{currentSettingsTab === 'audio' && <VolumeSettings />}
						{currentSettingsTab === 'video' && <VideoSettings />}
						{currentSettingsTab === 'virtualBg' && <VirtualBgSettings />}
						{currentSettingsTab === 'appearance' && <AppearanceSettings />}

					</Grid>
				</Grid>
			</DialogContent>

			<DialogActions>
				<Button onClick={() => handleCloseSettings(false)} color='primary'>
					<FormattedMessage
						id='label.close'
						defaultMessage='Close'
					/>
				</Button>
			</DialogActions>
		</Dialog>
	);
};

Settings.propTypes =
{
	currentSettingsTab  : PropTypes.string.isRequired,
	settingsOpen        : PropTypes.bool.isRequired,
	handleCloseSettings : PropTypes.func.isRequired,
	setSettingsTab      : PropTypes.func.isRequired,
	classes             : PropTypes.object.isRequired
};

const mapStateToProps = (state) =>
	({
		currentSettingsTab : state.room.currentSettingsTab,
		settingsOpen       : state.room.settingsOpen
	});

const mapDispatchToProps = {
	handleCloseSettings : roomActions.setSettingsOpen,
	setSettingsTab      : roomActions.setSettingsTab
};

export default connect(
	mapStateToProps,
	mapDispatchToProps,
	null,
	{
		areStatesEqual : (next, prev) =>
		{
			return (
				prev.room.currentSettingsTab === next.room.currentSettingsTab &&
				prev.room.settingsOpen === next.room.settingsOpen
			);
		}
	}
)(withStyles(styles)(Settings));